import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";
import CreateTravelPost from "./CreateTravelPost";

export default function TravelFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tripType, setTripType] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [editingPost, setEditingPost] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleEditPost = (post) => {
    setSelectedTrip(null);
    setEditingPost(post);
  };

  const handlePostCreated = (newPost) => {
    setPosts((prev) => [newPost, ...prev]);
    setShowCreateModal(false);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedTrip(null);
  };

  const tripTypes = [
    { id: "all", name: "Todos" },
    { id: "beach", name: "Praia" },
    { id: "mountain", name: "Montanha" },
    { id: "city", name: "Cidade" },
    { id: "adventure", name: "Aventura" },
    { id: "cultural", name: "Cultural" },
    { id: "romantic", name: "Romântico" },
    { id: "family", name: "Família" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/travel?page=${pageNum}&limit=12`;
      if (tripType !== "all") url += `&tripType=${tripType}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching travel:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [tripType]);

  if (loading && posts.length === 0) {
    return <div className="travel_feed_loading"><div className="travel_loader"></div><span>Carregando destinos...</span></div>;
  }

  return (
    <div className="travel_feed">
      {/* Create Post Button */}
      <div className="travel_create_section">
        <button
          className="travel_create_btn"
          onClick={() => setShowCreateModal(true)}
        >
          <span>✈️</span>
          <span>Compartilhe uma viagem</span>
        </button>
      </div>

      {tripTypes.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {tripTypes.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${tripType === filter.id ? "active" : ""}`}
                onClick={() => setTripType(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="travel_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
          <h3>Nenhum destino encontrado</h3>
          <p>Compartilhe suas viagens!</p>
        </div>
      ) : (
        <div className="travel_grid">
          {posts.map((post) => (
            <div key={post._id} className="travel_card" onClick={() => setSelectedTrip(post)}>
              <div className="travel_card_image">
                <img src={post.travelData?.photos?.[0] || post.images?.[0]?.url || post.images?.[0] || "/images/default-travel.png"} alt="" />
                <div className="travel_overlay">
                  <span className="travel_destination">{post.travelData?.destination}</span>
                </div>
                <span className="travel_type_badge">
                  {tripTypes.find(t => t.id === post.travelData?.tripType)?.name || "Viagem"}
                </span>
              </div>
              <div className="travel_card_content">
                <div className="travel_info_row">
                  <span className="travel_duration">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                    </svg>
                    {post.travelData?.duration || "—"} dias
                  </span>
                  <span className="travel_budget">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                    {post.travelData?.budget ? `R$ ${post.travelData.budget.toLocaleString("pt-BR")}` : "A definir"}
                  </span>
                </div>
                {post.travelData?.highlights?.length > 0 && (
                  <div className="travel_highlights">
                    {post.travelData.highlights.slice(0, 3).map((h, i) => (
                      <span key={i}>{h}</span>
                    ))}
                  </div>
                )}
                <Link to={`/profile/${post.user.username}`} className="travel_author" onClick={(e) => e.stopPropagation()}>
                  <img src={post.user.picture} alt="" />
                  <span>{post.user.first_name}</span>
                </Link>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="travel_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais destinos"}
          </button>
        </div>
      )}

      {selectedTrip && (
        <div className="travel_modal_overlay" onClick={() => setSelectedTrip(null)}>
          <div className="travel_modal" onClick={(e) => e.stopPropagation()}>
            <button className="travel_modal_close" onClick={() => setSelectedTrip(null)}>✕</button>

            <div className="travel_modal_gallery">
              <img src={selectedTrip.travelData?.photos?.[0] || selectedTrip.images?.[0]} alt="" />
            </div>

            <div className="travel_modal_body">
              <span className="travel_modal_type">
                {tripTypes.find(t => t.id === selectedTrip.travelData?.tripType)?.name}
              </span>
              <h2>{selectedTrip.travelData?.destination}</h2>

              <div className="travel_modal_stats">
                <div className="travel_stat">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                  <div>
                    <span className="travel_stat_value">{selectedTrip.travelData?.duration || "—"}</span>
                    <span className="travel_stat_label">dias</span>
                  </div>
                </div>
                <div className="travel_stat">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                  </svg>
                  <div>
                    <span className="travel_stat_value">R$ {(selectedTrip.travelData?.budget || 0).toLocaleString("pt-BR")}</span>
                    <span className="travel_stat_label">orçamento</span>
                  </div>
                </div>
                <div className="travel_stat">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
                  </svg>
                  <div>
                    <span className="travel_stat_value">{selectedTrip.travelData?.bestSeason || "Qualquer"}</span>
                    <span className="travel_stat_label">época</span>
                  </div>
                </div>
              </div>

              {selectedTrip.travelData?.highlights?.length > 0 && (
                <div className="travel_modal_section">
                  <h4>Destaques</h4>
                  <div className="travel_highlights_list">
                    {selectedTrip.travelData.highlights.map((h, i) => (
                      <span key={i}>
                        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                        </svg>
                        {h}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {selectedTrip.travelData?.tips?.length > 0 && (
                <div className="travel_modal_section">
                  <h4>Dicas do viajante</h4>
                  <ul className="travel_tips_list">
                    {selectedTrip.travelData.tips.map((tip, i) => (
                      <li key={i}>{tip}</li>
                    ))}
                  </ul>
                </div>
              )}

              {(selectedTrip.travelData?.description || selectedTrip.text) && (
                <div className="travel_modal_section">
                  <h4>Sobre a viagem</h4>
                  <p className="travel_modal_desc">{selectedTrip.travelData?.description || selectedTrip.text}</p>
                </div>
              )}

              {selectedTrip.travelData?.photos?.length > 1 && (
                <div className="travel_modal_section">
                  <h4>Fotos</h4>
                  <div className="travel_photos_grid">
                    {selectedTrip.travelData.photos.slice(1, 5).map((photo, i) => (
                      <img key={i} src={photo} alt="" />
                    ))}
                  </div>
                </div>
              )}

              <Link to={`/profile/${selectedTrip.user.username}`} className="travel_traveler">
                <img src={selectedTrip.user.picture} alt="" />
                <div>
                  <span className="travel_traveler_label">Viajante</span>
                  <span className="travel_traveler_name">{selectedTrip.user.first_name} {selectedTrip.user.last_name}</span>
                </div>
              </Link>

              <button className="travel_save_btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"/>
                </svg>
                Salvar destino
              </button>
            </div>
          </div>

      {showCreateModal && (
        <CreateTravelPost
          user={user}
          onPostCreated={handlePostCreated}
          onClose={() => setShowCreateModal(false)}
        />
      )}
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
